import { pageMeta } from "~/lib/meta"
import { ButtonLink } from "~/components/ui/button"
import { Wordmark } from "~/components/landing/Wordmark"

// The branded 404. Rendered by the catch-all route's ErrorBoundary, and by any
// route whose loader throws a 404 for an unknown param (blog categories): a
// route with its own loader matches before the catch-all, so without its own
// ErrorBoundary React Router falls back to its bare default error page.

// The <meta> block for a not-found page: a real title, and noindex so a
// 404 never gets indexed even if a crawler ignores the status code.
export function notFoundMeta(pathname: string) {
  return pageMeta({
    title: "Page not found · Pine59",
    robots: "noindex, nofollow",
    pathname,
  })
}

export function NotFound({
  title = "Page not found",
  body = "The page you are looking for does not exist or has moved.",
}: {
  title?: string
  body?: string
}) {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-cream px-6 text-center">
      <Wordmark className="justify-center" />
      <h1 className="mt-10 font-sans text-4xl font-semibold tracking-tight text-ink">
        {title}
      </h1>
      <p className="mt-4 max-w-md text-[17px] leading-relaxed text-mute">
        {body}
      </p>
      <ButtonLink href="/" className="mt-8">
        Back to the front page
      </ButtonLink>
    </main>
  )
}
